import React from 'react';
import HeroBanner from '../components/sections/HeroBanner';
import ServicesSection from '../components/sections/ServicesSection';
import BenefitsSection from '../components/sections/BenefitsSection';
import ComplianceSolution from '../components/sections/ComplianceSolution';
import BusinessStartup from '../components/sections/BusinessStartup';
import PricingSection from '../components/sections/PricingSection';
import FaqSection from '../components/sections/FaqSection';
const Home = () => {


    const GST_PLANS = [
        {
            tag: "LEDGERS",
            title: "GST Registration & Software",
            price: "5,899",
            duration: "yr",
            isHighlighted: false,
            features: ["GST Registration Support", "GST Certificate", "Compliance Dashboard", "LEDGERS GST Software Access", "Payroll Software"]
        },
        {
            tag: "Accountant",
            title: "GST Registration & 3-Month Accountant",
            price: "7,899",
            duration: "quarter",
            isHighlighted: false,
            features: ["All Software Features", "Dedicated Accountant Support", "GST Return Filing (GSTR-1, 3B)", "Invoice Management System"]
        },
        {
            tag: "Most popular",
            title: "GST Registration & 1-Year Accountant",
            price: "19,899",
            duration: "yr",
            isHighlighted: true, // This will make the card bigger and blue-bordered
            features: ["All Quarterly Features", "GST Annual Filing (GSTR-9)", "Annual Financial Statements", "Income Tax Return Filing", "CA Consultation"]
        }
    ];

    const ITR_FAQS = [
        {
            question: "What is the last date to file ITR for FY 2024-25?",
            answer: "The standard deadline for individuals whose accounts are not required to be audited is July 31st of the assessment year. However, it's always best to file early to avoid last-minute portal glitches."
        },
        {
            question: "Which ITR form should I select?",
            answer: "Selection depends on your income sources. ITR-1 is for salaried individuals with one house property, while ITR-3 or ITR-4 are for business/professional income. Our platform automatically picks the right form for you based on your data."
        },
        {
            question: "Is it mandatory to file ITR if my income is below 2.5 Lakhs?",
            answer: "Generally no, but filing is beneficial if you want to claim a TDS refund, apply for a visa, or seek a loan approval as it serves as a valid income proof."
        }
    ];
    return (
        <>
            <HeroBanner />
            <PricingSection
                title="Simple, Transparent GST Registration Pricing"
                subtitle="Apply for your GST Registration online with expert assistance."
                plans={GST_PLANS}
            />
            <ServicesSection />
            <BenefitsSection />
            <ComplianceSolution />
            <BusinessStartup />
            <FaqSection
                title="Frequently Asked Questions"
                subtitle="Quick answers to common questions about income tax filing in India."
                faqs={ITR_FAQS}
            />
        </>
    );
};

export default Home;
